import React, { useReducer, useState } from "react";
import { Outlet } from "react-router-dom";

function Employee() {
  const initialState: any = {};
  const reducer = (state: any, action: any) => {
    switch (action.type) {
      case "employeeDetailView":
        return { data: action.data };
      case "clearDetailview":
        return { data: {} };
      case "SET_BUNIT_DATA":
        let val = {
          ...state,
          data: {
            ...state.data,
            userData: {
              ...state.data.userData,
              businessUnitIds: { ...action.data },
            },
          },
        };
        return val;
      default:
        return state;
    }
  };
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <div className="flex pw-height-100v pw-overflow-y-auto">
      <Outlet context={[state, dispatch]} />
    </div>
  );
}

export default Employee;
